export enum SUPPORTED_FILE_FORMATS {
  'pdf' = 'application/pdf',
  'png' = 'image/png',
  'jpg' = 'image/jpeg',
}

export const formatAsFileSize = (bytes: number, decimal = 2): string => {
  const unit = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (!bytes && '0 Bytes') || `${(bytes / 1024 ** i).toFixed(decimal)} ${unit[i]}`;
};

export const getFileExtension = (name: string): string => {
  const lastDot = name.lastIndexOf('.');
  return name.substring(lastDot + 1).toLowerCase() || '';
};

export const getFileMimeType = (documentFormat: string): string => {
  return SUPPORTED_FILE_FORMATS[documentFormat];
};

export const parseAndDownloadBase64FileString = async (name: string, mimeType: string, payload: string) => {
  const url = `data:${mimeType};base64,${payload}`;
  const hiddenElement = document.createElement('a');
  hiddenElement.href = url;
  hiddenElement.download = name;
  document.body.appendChild(hiddenElement);
  hiddenElement.click();
  document.body.removeChild(hiddenElement);
  window.URL.revokeObjectURL(url);
  const res: Response = await fetch(url);
  const blob: Blob = await res.blob();
  return new File([blob], name, { type: mimeType });
};

export const parseAndDownloadBinaryFileBlob = async (name: string, blob: Blob) => {
  const url = URL.createObjectURL(blob);
  const hiddenElement = document.createElement('a');
  hiddenElement.href = url;
  hiddenElement.download = name;
  document.body.appendChild(hiddenElement);
  hiddenElement.click();
  document.body.removeChild(hiddenElement);
  URL.revokeObjectURL(url);
};
